export default defineNuxtPlugin((nuxtApp) => {
  const auth = useAuth()
  const idle = useIdleStore()

  const IDLE_MS = 20 * 60 * 1000
  const CONFIRM_SECONDS = 30

  let idleTimer = null
  let confirmTimer = null
  let confirmInterval = null

  const activityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click']

  console.log('[idle-guard] plugin loaded')

  const isAuthed = () => auth.status.value === 'authenticated'

  const clearTimers = () => {
    if (idleTimer) clearTimeout(idleTimer)
    if (confirmTimer) clearTimeout(confirmTimer)
    if (confirmInterval) clearInterval(confirmInterval)
    idleTimer = null
    confirmTimer = null
    confirmInterval = null
  }

  const schedule = () => {
    clearTimers()
    idle.close()

    if (!isAuthed()) return

    idleTimer = setTimeout(() => {
      console.log('[idle-guard] idle timeout -> open modal')
      idle.open(CONFIRM_SECONDS)

      confirmInterval = setInterval(() => idle.tick(), 1000)

      confirmTimer = setTimeout(async () => {
        console.log('[idle-guard] confirm timeout -> logout')
        idle.close()
        await nuxtApp.$router.push('/auth/logout')
      }, CONFIRM_SECONDS * 1000)
    }, IDLE_MS)
  }

  const onActivity = () => {
    if (!isAuthed()) return

    if (idle.show) {
      console.log('[idle-guard] activity while modal open -> close')
      idle.close()
    }

    schedule()
  }

  const attach = () => {
    console.log('[idle-guard] attach listeners')
    activityEvents.forEach(e => window.addEventListener(e, onActivity, { passive: true }))
  }

  const detach = () => {
    console.log('[idle-guard] detach listeners')
    activityEvents.forEach(e => window.removeEventListener(e, onActivity))
  }

  const onStay = () => onActivity()
  window.addEventListener('idle:stay', onStay)

  watch(
    () => auth.status.value,
    (s) => {
      console.log('[idle-guard] auth.status =', s)
      if (s === 'authenticated') {
        attach()
        schedule()
      } else {
        detach()
        clearTimers()
        idle.close()
      }
    },
    { immediate: true }
  )

  nuxtApp.hook('app:beforeUnmount', () => {
    window.removeEventListener('idle:stay', onStay)
    detach()
    clearTimers()
  })
})
